import script from "./TaxForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxForm.vue?vue&type=script&setup=true&lang=js"

import "./TaxForm.vue?vue&type=style&index=0&id=d3ce0b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3ce0b78"]])

export default __exports__